import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
//// import { mainStyles, theme } from '../../styles'
import {
    Typography, useTheme
} from '@mui/material'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DeleteIcon from '@mui/icons-material/Delete';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import PersonIcon from '@mui/icons-material/Person';
import ErrorIcon from '@mui/icons-material/Error';

import { CustomControls, Buttons, LinkButton } from '../../components'

export function ListElementforEdit(props) {
    const statusColor = theme.palette.primary.main
    const localStyles = {} //mainStyles.bodyStyles()
    const theme = useTheme()
    const location = useLocation()

    return (
        <div
            key={props.keyProps}
            className={localStyles.listElementStyle}>
            <div
                className={props.newItem ? localStyles.greySquare : localStyles.redSquare}
                key={`div_${props.keyProps}`}>
                {props.text === 'Presidente'
                    ? <AccountBoxIcon style={{ color: "#ffffff" }} /> :
                    props.text === 'Tesorero'
                        ? <MonetizationOnIcon style={{ color: "#ffffff" }} /> :
                        props.text === 'Secretario'
                            ? <PermPhoneMsgIcon style={{ color: "#ffffff" }} /> :
                            props.text === 'Socio'
                                ? <PersonIcon style={{ color: "#ffffff" }} /> :
                                <ErrorIcon style={{ color: "#ffffff" }} />
                }
            </div>
            <div className={localStyles.elementDetails}>
                <Typography
                    variant="caption"
                    display="block"
                    gutterBottom
                    className={localStyles.listText} >
                    {props.text}
                </Typography>

                {props.description &&
                    <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={localStyles.description}
                    >
                        {props.description}
                    </Typography>
                }

                <div className={localStyles.deleteSection} onClick={props.clickStatus} type='button'>
                    {props.delete && <DeleteIcon
                        className={localStyles.deleteIcon} />}

                    <LinkButton LinkButtonText="name button" LinkButtonUrl=""
                        text_size={14}
                        text_color={statusColor}
                        text={props.status}
                        type='button'
                    />

                </div>

            </div>
            <ArrowDropDownIcon
                onClick={props.arrowOnClick}
                key={`arrow_${props.keyProps}`} />
        </div>
    )
}